module.exports = __webpack_public_path__ + "img/funnel.3d7b3297.png";